import React from "react";

const Stepper = ({
  title,
  description,
  lineType = "dashed",
  imgSrc,
  imgAlt,
  primaryText = true,
  navDesc = true,
}) => (
  <div className="infostep">
    <div className="d-flex flex-row gap-2">
      <img src={imgSrc} alt={imgAlt} className="infostep-img" />
      <p
        className={`flow-gap ${
          primaryText ? "text-primary-600" : "text-black"
        } mb-0`}
      >
        {title}
      </p>
    </div>
    <div className="d-flex flex-row stepper-margin">
      <div className={`${lineType}-step-line`}>
        <p
          className={`flow-gap ${
            navDesc ? "text-dark-6" : "text-gray-1"
          } mb-4 mt-1 text-margin`}
        >
          {description}
        </p>
      </div>
    </div>
  </div>
);

export default Stepper;
